// import React from 'react';

// import mainImage from '../images/resource/image-21.jpg';
// import smallImage from '../images/resource/image-22.jpg';

// const WhyChooseUs = () => {
//   return (
//     <section className="why-choose-us-section light-bg mx-60 pt-0 border-shape-bottom">
//       <div className="auto-container">
//         <div className="title-box text-center">
//           <div className="sub-title">Our Features</div>
//           <h2 className="sec-title mb-30">Why Choose Us</h2>
//           <div className="text">
//             Our objective at Bluebell is to bring together our visitor's societies and spirits with our own, communicating enthusiasm–
//             <br /> and liberality in the food we share. Official Chef and Owner Philippe Massoud superbly.
//           </div>
//         </div>

//         <div className="row">
//           <div className="col-lg-6 why-choose-us-block">
//             <div className="image">
//               <img src={mainImage} alt="Why Choose Us" />
//             </div>
//             <div className="inner-box">
//               <div className="image-block">
//                 <img src={smallImage} alt="Visitors" />
//               </div>
//               <div className="text-three">
//                 <span>1350 +</span> Visitors <br /> Come Annually
//               </div>
//             </div>
//           </div>

//           <div className="col-lg-6 why-choose-us-block">
//             <div className="text-two">
//               At Bluebell, we understand the different expectations of visitors. We feel elated when you come back for the second time!
//             </div>

//             <div className="icon-list">
//               <ul>
//                 <li><i className="flaticon-checkmark"></i> Spa/gym</li>
//                 <li><i className="flaticon-checkmark"></i> Meditation</li>
//                 <li><i className="flaticon-checkmark"></i> Shopping</li>
//                 <li><i className="flaticon-checkmark"></i> Trekking</li>
//                 <li><i className="flaticon-checkmark"></i> Sightseeing</li>
//                 <li><i className="flaticon-checkmark"></i> Elephant safari</li>
//                 <li><i className="flaticon-checkmark"></i> Facials/makeup</li>
//                 <li><i className="flaticon-checkmark"></i> Live music band</li>
//                 <li><i className="flaticon-checkmark"></i> Night Bonfire</li>
//               </ul>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default WhyChooseUs;


import React from 'react';

import mainImage from '../images/resource/water.jpg';
import smallImage from '../images/resource/image-22.jpg';

const WhyChooseUs = () => {
  return (
    <section className="why-choose-us-section light-bg mx-60 pt-0 border-shape-bottom">
      <div className="auto-container">
        <div className="title-box text-center">
          <div className="sub-title">Our Features</div>
          <h2 className="sec-title mb-30">Why Choose Woodland Escape</h2>
          <div className="text">
            At Woodland Escape Resort, we offer an unforgettable experience amidst the heart of the forest, where nature and wildlife meet comfort and adventure.  
            <br /> From peaceful forest walks to spotting majestic tigers, every moment here is designed to connect you with the wilderness.
          </div>
        </div>

        <div className="row">
          <div className="col-lg-6 why-choose-us-block">
            <div className="image">
              <img src={mainImage} alt="Why Choose Us" />
            </div>
            <div className="inner-box">
              {/* <div className="image-block">
                <img src={smallImage} alt="Visitors" />
              </div> */}
              {/* <div className="text-three">
                <span>1500 +</span> Visitors  <br />
                 Enjoy Nature Annually
              </div> */}
            </div>
          </div>

          <div className="col-lg-6 why-choose-us-block">
            <div className="text-two">
              We understand that every guest seeks something unique — adventure, serenity, or a family retreat.  
              Woodland Escape is designed to fulfill all these, ensuring you leave with memories that last a lifetime.
            </div>

            <div className="icon-list">
              <ul>
                {/* <li><i className="flaticon-checkmark"></i> Spa & Wellness</li> */}
                <li><i className="flaticon-checkmark"></i> Guided Forest Walks</li>
                <li><i className="flaticon-checkmark"></i> Bird Watching</li>
                <li><i className="flaticon-checkmark"></i> Jungle Trekking</li>
                <li><i className="flaticon-checkmark"></i> Wildlife Safari</li>
                <li><i className="flaticon-checkmark"></i> Night Bonfire & Stories</li>
                <li><i className="flaticon-checkmark"></i> Organic Meals</li>
                <li><i className="flaticon-checkmark"></i> Photography Tours</li>
                <li><i className="flaticon-checkmark"></i> Relaxing Meditation Spots</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
